<template>
  <div>
    <b-container variant="primary" fluid class="p-5">
      <b-row>
        <b-col :cols="12">
          <h2>Presupuestos</h2>
          <p>
            En este apartado se pueden gestionar los presupuestos de la tienda
            de {{ locationInfo ? locationInfo.name : '' }}.
          </p>
          <b-row class="mb-3">
            <b-col :cols="12"> </b-col>
          </b-row>

          <b-row>
            <b-col :cols="12">
              <h3>Listado de presupuestos</h3>
              <v-server-table
                name="quotes"
                :url="table.url"
                ref="table"
                class="mt-4"
                :columns="table.columns"
                :options="table.options"
              >
                <div slot="afterFilterWrapper" class="form-group form-inline">
                  <b-button
                    class="ml-3"
                    variant="primary"
                    :to="{
                      name: 'AdminQuotesEditScreen',
                      params: { id: 'new', location: this.location },
                    }"
                    >Nuevo presupuesto</b-button
                  >

                  <!-- <b-button
                    variant="outline-danger"
                    class="ml-2"
                    :disabled="table.selected.length === 0"
                    @click="removeSelected()"
                    >Eliminar seleccionados</b-button
                  > -->
                </div>

                <div slot="h__checkbox">
                  <b-form-checkbox
                    v-model="table.allSelected"
                    @change="toggleAll"
                  />
                </div>

                <div slot="checkbox" slot-scope="props">
                  <b-form-checkbox
                    :checked="table.selected.includes(props.row.reference)"
                    @change="toggleCell($event, props.row.reference)"
                  />
                </div>

                <template v-slot:modified_at="props">
                  <span>{{ props.row.modified_at }}</span>
                </template>

                <template v-slot:abbr_product_names="props">
                  <div
                    :key="i"
                    v-for="(abbr_product_name, i) in props.row
                      .abbr_product_names"
                  >
                    {{
                      abbr_product_name['qty'] +
                      ' x ' +
                      abbr_product_name['name']
                    }}
                  </div>
                </template>

                <template v-slot:created_at="props">
                  <span>{{ props.row.created_at }}</span>
                </template>

                <template v-slot:total_price="props">
                  <span>{{ props.row.total_price }} €</span>
                </template>

                <template v-slot:created_by="props">
                  <span>{{
                    props.row.created_by.map((x) => x.first_name).join(', ')
                  }}</span>
                </template>

                <template v-slot:orders="props">
                  <div :key="order" v-for="order in props.row.order_set">
                    <b-link
                      :to="{
                        name: 'AdminOrdersEditScreen',
                        params: { id: order },
                      }"
                      >{{ order }}
                    </b-link>
                  </div>
                </template>

                <template v-slot:workshop_orders="props">
                  <div
                    :key="workshop_order"
                    v-for="workshop_order in props.row.workshoporder_set"
                  >
                    <b-link
                      :to="{
                        name: 'AdminWorkshopOrdersEditScreen',
                        params: { id: workshop_order },
                      }"
                      >{{ workshop_order }}
                    </b-link>
                  </div>
                </template>

                <template v-slot:actions="props">
                  <b-button-group>
                    <b-button
                      :to="{
                        name: 'AdminQuotesEditScreen',
                        params: { id: props.row.id },
                      }"
                      size="sm"
                      variant="outline-primary"
                      ><b-icon icon="pencil" aria-hidden="true" />
                    </b-button>

                    <b-button
                      @click="duplicateQuote(props.row.id)"
                      variant="outline-primary"
                      size="sm"
                      ><b-icon icon="files"></b-icon
                    ></b-button>

                    <b-button
                      @click="downloadQuote(props.row.id)"
                      size="sm"
                      variant="outline-primary"
                      ><b-icon icon="download" aria-hidden="true"></b-icon
                    ></b-button>

                    <b-button
                      @click="downloadQuoteWorkshop(props.row.id)"
                      size="sm"
                      variant="outline-primary"
                      ><b-icon icon="gear-fill" aria-hidden="true"></b-icon>
                      Orden de taller</b-button
                    >
                    <b-button
                      @click="removeQuote(props.row.id)"
                      size="sm"
                      variant="outline-danger"
                      ><b-icon icon="trash" aria-hidden="true" />
                    </b-button>
                  </b-button-group>
                </template>
              </v-server-table>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { uris, actions } from '@/admin/api.js';

import store from '@/admin/store.js';

import moment from 'moment';
import 'moment/locale/es';

export default {
  name: 'AdminQuotesScreen',
  props: ['location'],
  components: {},
  data() {
    return {
      table: {
        url: uris.quotesByLocationURI(this.location),
        selected: [],
        allSelected: false,
        columns: [
          'checkbox',
          'id',
          'customer_full_name',
          'abbr_product_names',
          'total_price',
          'created_at',
          'created_by',

          // 'modified_at',
          'orders',
          'workshop_orders',
          'actions',
        ],
        options: {
          saveState: true,
          sortable: ['modified_at', 'created_at'],
          headings: {
            customer_full_name: 'Cliente',
            abbr_product_names: 'Productos',
            // modified_at: 'Fecha modif.',
            created_by: 'Creado por',
            created_at: 'Fecha creación',
            total_price: 'Total',
            id: '# Presupuesto',
            orders: '# Venta',
            workshop_orders: '# Pedido',
            actions: 'Acciones',
          },
        },
      },
      locationInfo: null,
      sharedState: store.state,
    };
  },
  created() {
    Promise.all([actions.getLocationById(this.location)]).then((x) => {
      this.locationInfo = x[0].data;
    });

    this.$watch(
      () => this.$route.params,
      (toParams, previousParams) => {
        this.table.url = uris.quotesByLocationURI(this.location);
        // this.$refs.table.refresh();
      }
    );
  },
  filters: {
    formatDateTime: function (value) {
      return moment(value).format('DD/MM/YYYY HH:mm');
    },
    formatCurrency(val) {
      return val.toFixed(2);
    },
  },
  methods: {
    duplicateQuote(id) {
      actions.postQuoteDuplicate(id).then((x) => {
        this.$bvModal.msgBoxOk(`Presupuesto duplicado correctamente`);
        this.$refs.table.refresh();
      });
    },
    downloadQuoteWorkshop(id) {
      actions.downloadQuoteWorkshop(id).then((x) => {
        let fileName = 'Orden-taller-provisional.html';

        console.log();

        var winPrint = window.open(
          '',
          '',
          'left=0,top=0,width="100%",height="100%",toolbar=1,scrollbars=1,status=0'
        );
        winPrint['BASE_URL'] = process.env.VUE_APP_API_BASE_URL.replace(
          'api/',
          ''
        );
        winPrint.document.write(x.data);
        winPrint.document.close();
        // winPrint.print();
        winPrint.focus();

        // const contentDisposition = x.headers['content-disposition'];
        // if (contentDisposition) {
        //   const fileNameMatch = contentDisposition.match(/filename=(.+)/);
        //   if (fileNameMatch.length === 2) {
        //     fileName = fileNameMatch[1];
        //   }
        // }

        // let blob = new Blob([x.data], { type: 'application/pdf' });

        // let link = document.createElement('a');
        // link.href = window.URL.createObjectURL(blob);
        // link.download = fileName;
        // link.click();
      });
      // uris.quoteDownloadURI(id);
    },
    downloadQuote(id) {
      actions.downloadQuote(id).then((x) => {
        let fileName = 'Presupuesto.pdf';

        const contentDisposition = x.headers['content-disposition'];
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename=(.+)/);
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1];
          }
        }

        let blob = new Blob([x.data], { type: 'application/pdf' });

        let link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
      });
      // uris.quoteDownloadURI(id);
    },
    // removeSelected() {
    //   this.table.selected.map((x) => {
    //     this.removeQuote(x);
    //   });
    // },
    removeQuote(id) {
      if (
        confirm(
          '¿Estás seguro que deseas eliminar el presupuesto número ' + id + '?'
        )
      ) {
        actions
          .deleteQuote(id)
          .then((x) => {
            this.$refs.table.refresh();
          })
          .catch((err) => {
            if (
              err.response.status == 400 &&
              err.response.data === 'ERROR_PROTECTED'
            ) {
              alert(
                'No pudo eliminarse el presupuesto, ya que está asociado a un pedido'
              );
            }
          });
      }
    },
    toggleCell($event, id) {
      if ($event) {
        this.table.selected.push(id);
      } else {
        this.table.selected = this.table.selected.filter((item) => item !== id);
      }
    },
    toggleAll(checked) {
      this.table.selected = checked
        ? this.$refs.table.data.map((row) => row.reference)
        : [];
    },
  },
  mounted() {},
};
</script>

<style scoped></style>
